import { useContext, useEffect } from 'react';

import { NavbarContext } from '../contexts/navbar';
import { ViewportContext } from '../contexts/viewport';
import {
  PIXELS_FOR_NAVBAR_SCROLL_STATE,
  SET_NAVBAR_STATE_PROP,
  SWITCH_NAVBAR_STATE
} from '../utils/variables';
import { useDetectScroll } from './useDetectScroll';
import { usePaths } from './usePaths';

export const useNavbar = () => {
  const { currentPath, currentPathHash } = usePaths();
  const { scroll } = useDetectScroll(PIXELS_FOR_NAVBAR_SCROLL_STATE);
  const { state, dispatch } = useContext(NavbarContext);
  const { activeNavlink, activeSubNavlink, isNavbarTransparent, isBurgerMenu } =
    state;
  const { isDesktop } = useContext(ViewportContext);

  // NAVBAR STATE CHANGE FUNCTIONS
  const onClickBurger = () => {
    dispatch({
      type: SWITCH_NAVBAR_STATE,
      payload: 'isBurgerMenu'
    });
  };

  const onClickSubNavlink = (value) => {
    dispatch({
      type: SET_NAVBAR_STATE_PROP,
      payload: { prop: 'activeSubNavlink', value }
    });
  };

  const setIsNavbarTransparent = (value) => {
    dispatch({
      type: SET_NAVBAR_STATE_PROP,
      payload: {
        prop: 'isNavbarTransparent',
        value: value
      }
    });
  };

  const setActiveNavlinks = (navlinks) => {
    const navlink = navlinks?.find((navlink) =>
      navlink?.subButtons?.find(
        (s) => s.page?.gatsbyPath === currentPath?.gatsbyPath
      )
    );
    const subNavlink = navlink?.subButtons?.find((subButton) => {
      if (currentPathHash) {
        return currentPathHash.includes(subButton.scrollTo?.identifier);
      }
      return subButton.page?.gatsbyPath === currentPath?.gatsbyPath;
    });
    dispatch({
      type: SET_NAVBAR_STATE_PROP,
      payload: { prop: 'activeNavlink', value: navlink }
    });
    dispatch({
      type: SET_NAVBAR_STATE_PROP,
      payload: { prop: 'activeSubNavlink', value: subNavlink }
    });
  };

  const isActiveNavLink = (navlink) => {
    return activeNavlink?.contentful_id === navlink?.contentful_id;
  };
  const isActiveSubNavlink = (subNavLink) => activeSubNavlink === subNavLink;

  useEffect(() => {
    dispatch({
      type: SET_NAVBAR_STATE_PROP,
      payload: { prop: 'isBurgerMenu', value: false }
    });
  }, [isDesktop]);

  return {
    scroll,
    activeNavlink,
    activeSubNavlink,
    isNavbarTransparent,
    isBurgerMenu,
    onClickBurger,
    onClickSubNavlink,
    setIsNavbarTransparent,
    setActiveNavlinks,
    isActiveNavLink,
    isActiveSubNavlink
  };
};
